import type { LinkProps } from '@tanstack/react-router';
import {
  Building2,
  ClipboardList,
  Compass,
  DollarSign,
  FileSignature,
  FileText,
  Landmark,
  ListChecks,
  Mail,
  Settings,
  ShieldCheck,
  Ticket,
  Users,
  type LucideIcon,
} from 'lucide-react';

/** Pozycja menu aplikacji — cel podany literałem trasy, nie sklejonym adresem. */
export interface AppMenuItem extends Pick<LinkProps, 'to'> {
  label: string;
  icon: LucideIcon;
}

export interface AppMenuSection {
  label: string;
  items: readonly AppMenuItem[];
}

/**
 * Jedyne miejsce, w którym żyją etykiety, ikony i cele menu — sidebar na
 * szerokim ekranie i arkusz kafli na telefonie rysują tę samą listę.
 */
export const APP_MENU_SECTIONS: readonly AppMenuSection[] = [
  {
    label: 'Wyjazdy',
    items: [
      { label: 'Moje wyjazdy', icon: Compass, to: '/app/tours' },
      { label: 'Uczestnicy', icon: Users, to: '/app/participants' },
      { label: 'Zapisujący', icon: FileText, to: '/app/clients' },
      { label: 'Rezerwacje', icon: ClipboardList, to: '/app/bookings' },
      { label: 'Lista rezerwowa', icon: ListChecks, to: '/app/waitlist' },
    ],
  },
  {
    label: 'Firma',
    items: [
      { label: 'Finanse', icon: DollarSign, to: '/app/finances' },
      { label: 'TFG', icon: Landmark, to: '/app/tfg' },
      { label: 'Kody promocyjne', icon: Ticket, to: '/app/promo-codes' },
      { label: 'Umowy', icon: FileSignature, to: '/app/contracts' },
      { label: 'Ubezpieczenia', icon: ShieldCheck, to: '/app/insurances' },
      { label: 'Wiadomości', icon: Mail, to: '/app/messages' },
    ],
  },
  {
    label: 'System',
    items: [
      { label: 'Dostęp', icon: Building2, to: '/app/access' },
      {
        label: 'Ustawienia firmy',
        icon: Settings,
        to: '/app/company-settings',
      },
    ],
  },
];

export const APP_MENU_ITEMS: readonly AppMenuItem[] = APP_MENU_SECTIONS.flatMap(
  (section) => section.items,
);
